import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { merge, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { AclTipo } from 'src/app/model/AclTipo.enum';
import { CampiDataSource } from 'src/app/services/campi.datasource';
import { CampiService } from 'src/app/services/campi.service';
import { DialogService } from 'src/app/services/dialog.service';
import { TemplateService } from 'src/app/services/template.service';
import { Toolbar, ToolbarEvent } from 'src/app/shared/components/toolbar/toolbar';
import { DettaglioCampoComponent } from '../dettaglio-campo/dettaglio-campo.component';

@Component({
  selector: 'app-lista-campi-unica',
  templateUrl: './lista-campi-unica.component.html',
  styleUrls: ['./lista-campi-unica.component.css']
})
export class ListaCampiUnicaComponent implements OnInit {

  tpModulo: number;
  idTemplate: number;
  controlList: ModelEventiCalamitosi.CampoModuloDTO[] = [];
  public toolbar: Toolbar;
  public editToolbar: Toolbar;
  public orderToolbar: Toolbar;

  //tasto di aggiunta campi per template di tipo libero
  public menuAddLibero: Toolbar = {
    toolbarCss: 'toolbar-vertical',
    actions: [
      {
        btnTitle: 'Aggiungi nuovo campo',
        btnIconClass: 'add',
        btnActionEvent: 'new-libero',
        btnCssClass: 'btn btn-primary'
      }
    ]
  };

  @Input('campo') cambioCampo: Subject<number>;
  @Input('tpM') tpm: number;
  @Output() emitCampiPredConf = new EventEmitter<ModelEventiCalamitosi.CampoModuloDTO[]>();
  risultatiPerPagina: number = 10;
  displayedColumns: string[] = ['idCampo', 'descrizione', 'idTpCampoModulo', 'obbligatorio', 'predefinito', 'visualizzabile', 'actions'];
  dataSource: CampiDataSource;
  emptyTableMessage = false;
  allAbilitati: string = "";
  acl: string = "";
  templateDistribuito: string = "N";
  @Output() allCampiAbilitatiEvent = new EventEmitter<string>();
  @Input() resetAbilitaTuttiCampi: Subject<boolean>;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  isDettaglio: boolean;
  confirmed: boolean;

  public searchFilters: ModelEventiCalamitosi.CampoSearchableDto = {
    codiceCampo: this.route.snapshot.params.id,
    tipologia: null,
    etichetta: null,
    descrizione: null,
    obbligatorio: null,
    visualizzabile: null
  }
  openToggle: number;
  public checkAndSave: boolean = true;

  constructor(private templateSvc: TemplateService, private alertsCenterService: AlertsCenterService, private domSanitizer: DomSanitizer, public dialog: MatDialog, private listaCampiConfDilogSvc: DialogService, private matIconRegistry: MatIconRegistry, private campiService: CampiService, private router: Router, private route: ActivatedRoute) {
    // this.matIconRegistry.addSvgIcon(
    //   "add",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/add-24px.svg")
    // );
    // this.checkDistribuito();

    this.orderToolbar = {
      toolbarCss: 'toolbar-vertical',
      actions: [
        {
          btnTitle: 'Sposta su',
          btnIconClass: 'keyboard_arrow_up',
          btnActionEvent: 'up',
          btnCssClass: 'btn btn-secondary'
        },
        {
          btnTitle: 'Sposta giù',
          btnIconClass: 'keyboard_arrow_down',
          btnActionEvent: 'down',
          btnCssClass: 'btn btn-primary'
        }
      ]
    };

  }

  ngOnInit(): void {

    this.isDettaglio = this.router.url.includes("dettaglio-template");
    this.searchFilters.tipologia = this.tpm;
    this.dataSource = new CampiDataSource(this.campiService);

    this.dataSource.errors$.subscribe(res => {
      if (res) this.alertsCenterService.showAlert({
        message: `Errore lettura dati`,
        type: 'danger',
        autoClosable: false
      });
    })
    this.cambioCampo.subscribe(res => {
      this.tpModulo = res,
        this.idTemplate = this.route.snapshot.params.idTemplate,
        this.searchFilters = {
          codiceCampo: null,
          idTemplate: this.route.snapshot.params.idTemplate,
          tipologia: res,
          etichetta: null,
          descrizione: null,
          obbligatorio: null,
          visualizzabile: null
        }
      this.controlList = [];
      this.checkAndSave = true;
      this.allAbilitati = '';
      this.checkDistribuito();
      this.dataSource.loadCampiWithCheck(this.controlList, this.searchFilters, 'codiceCampo,ASC', this.paginator.pageIndex, this.paginator.pageSize, this.templateDistribuito, this.allAbilitati);
      this.dataSource.counter$.subscribe(res => {
        if (res === 0) this.emptyTableMessage = true;
      })
    })

    this.dataSource.loadComplete.subscribe(res => {
      if (res === true) {
        this.allAbilitati = "";
        this.allCampiAbilitatiEvent.emit(this.allAbilitati);
      }
    })

  }

  ngAfterViewInit() {

    this.paginator.page
      .pipe(
        tap(() => {
          this.ricercaListaCampi();
        }))
      .subscribe();

    this.dataSource.counter$
      .pipe(
        tap((count) => {
          this.paginator.length = count;
        })
      )
      .subscribe();
  }

  public ricercaListaCampi(resetPage?: boolean): void {
    this.dataSource.loadCampiWithCheck(this.controlList, this.searchFilters, "codiceCampo,ASC", this.paginator.pageIndex, this.paginator.pageSize, this.templateDistribuito, this.allAbilitati);
  }

  openDettaglioCampoDialog(idCampo: string, tipoVista: string, modeSaveSelection?: boolean, idCampoPrecedente?: number, pendingOperation?: boolean) {

    // Per la Fase2 un utente può creare un campo successivamente ad uno scelto
    // poichè nella toolbar appare la possibilità di poter creare un campo anche prima di
    // aver salvato il precedente allora controlliamo pendingOperation per
    // vedere se effettivamente deve salvare prima o meno
    // (senza questo controllo l'utente apre un nuovo template, seleziona un campo che vuole rendere visualizzabile
    // e senza salvare ha la possibilità di aprire la dialog di creazione del campo nuovo
    // Per evitare questo scenario e non appesantire troppo il BE allora controlliamo
    // questa variabile FE)
    if (!pendingOperation) {
      //inserire qui la configurazione della material dialog MatDialogConfig per dati e css
      const dialogConfig = new MatDialogConfig();

      dialogConfig.data = {
        idCampo: idCampo,
        idTemplate: this.idTemplate,
        tpModulo: this.tpModulo,
        tipoVista: tipoVista,
        predefiniti: false,
        // il campo modeSaveSelection è un flag che ci indica se:
        //1 - l'inserimento che si vuole effettuare è del primo campo di un template (es. primo campo di un template libero o la normale aggiunta) ---> false
        //2 - l'inserimento che si vuole effettuare è di un campo che si vuole inserire in mezzo ad altri già preesistenti ---> (Sviluppi FASE2) true
        modeSaveSelection: modeSaveSelection,
        //il campo idCampoPrecedente serve per la creazione di un campo subito sotto ad un altro
        //serve al BE per effettuare controlli e l'operazione di switch di tutti gli altri campi
        idCampoPrecedente: idCampoPrecedente !== null && idCampoPrecedente !== undefined ? idCampoPrecedente : 0
      }

      const dialogRef = this.dialog.open(DettaglioCampoComponent, dialogConfig);

      dialogRef.afterClosed().subscribe(result => {
        if (result == true) {
          this.emptyTableMessage = false;
        }
        this.ricercaListaCampi();
      });
    } else this.alertsCenterService.showAlert({
      message: `Prima di procedere con la creazione di un nuovo campo è necessario salvare`,
      type: 'danger',
      autoClosable: false
    });

  }

  openRemoveCampoDialog(idCampo: number, idTemplate: number) {
    let title = 'Cancellazione campo';
    let message = 'Vuoi davvero eliminare questo campo?'
    this.listaCampiConfDilogSvc.openDialog(title, message).subscribe(
      result => {
        this.confirmed = result;
        if (this.confirmed) {
          this.cancellaCampo(idCampo, idTemplate);
        }
      }
    );
  }

  openDuplicateInputDialog(data: ModelEventiCalamitosi.EventoDto) {
    let title = 'Duplicazione campo';
    let message = 'Definire una nuova etichetta da assegnare al campo';
    this.listaCampiConfDilogSvc.openCampoDupl(title, message, true, 'Etichetta*').subscribe(
      result => {
        if (result) this.duplicateCampo(data, result);
      }
    );
  }

  public cancellaCampo(idCampo: number, idTemplate: number): void {
    this.campiService.deleteCampo(idCampo, idTemplate).subscribe(results => {
      this.alertsCenterService.showAlert({
        message: `Cancellazione effettuata con successo`,
        type: 'success',
        autoClosable: false
      });
      this.ricercaListaCampi();
    }, error => {

      this.alertsCenterService.showAlert({
        message: `Errore durante la cancellazione`,
        type: 'danger',
        autoClosable: false
      });
    })
  }

  public listaTpCampo = [
    { value: 1, label: 'DATA' },
    { value: 2, label: 'DESCRITTIVO' },
    { value: 3, label: 'NUMERO' },
    { value: 4, label: 'TENDINA' },
    { value: 5, label: 'VALUTA' },
    { value: 6, label: 'COORDINATE' },
    { value: 7, label: 'LISTA VALORI MULTISELEZIONE' },
    { value: 8, label: 'CODICE FISCALE ' },
    { value: 9, label: 'PARTITA IVA' },
    { value: 10, label: 'INDIRIZZO EMAIL' },
  ]

  public showCampiTip(idTp: number): string {
    let tipologia: string;
    this.listaTpCampo.forEach(element => {
      if (idTp == element.value) tipologia = element.label
    });
    return tipologia
  }

  /**
*
*
* @private
* @memberof SearchComponent
*/
  public generateToolBar(element): Toolbar {

    /* Caso modifica template */
    if (this.router.url.includes('modifica-template')) {

      this.editToolbar = {
        toolbarCss: 'toolbar-vertical',
        actions: [
          // RF02 modifica valore obbligatorio anche per i non custom.
          {
            btnTitle: 'Modifica',
            btnIconClass: 'create',
            btnActionEvent: 'edit',
            btnCssClass: 'btn btn-secondary'
          },
          {
            btnTitle: 'Dettaglio',
            btnIconClass: 'article',
            btnActionEvent: 'detail',
            btnCssClass: 'btn btn-secondary'
          },
          {
            btnTitle: 'Aggiungi un nuovo campo sotto il campo selezionato',
            btnIconClass: 'add',
            btnActionEvent: 'add-new-under',
            btnCssClass: 'btn btn-primary'
          }
        ]
      };

      this.toolbar = {
        toolbarCss: 'toolbar-vertical',
        actions: [
          {
            btnTitle: 'Dettaglio',
            btnIconClass: 'article',
            btnActionEvent: 'detail',
            btnCssClass: 'btn btn-secondary'
          }
        ]
      };

      //Caso non distribuito, posso modificare campi configurabili
      if (this.templateDistribuito === "N") {

        //Se campo è configurabile aggiungo possibilità di modifica/eliminazione/duplicazione
        if (element.predefinito === 'N') {
          this.editToolbar.actions.push(
            /*{
              btnTitle: 'Modifica',
              btnIconClass: 'create',
              btnActionEvent: 'edit',
              btnCssClass: 'btn btn-secondary'
            },*/
            {
              btnTitle: 'Duplica campo',
              btnIconClass: 'content_copy',
              btnActionEvent: 'duplicate',
              btnCssClass: 'btn btn-secondary'
            },
            {
              btnTitle: 'Elimina campo',
              btnIconClass: 'delete',
              btnActionEvent: 'remove',
              btnCssClass: 'btn btn-primary'
            },
          );

          this.toolbar.actions.push(
            /*{
              btnTitle: 'Modifica',
              btnIconClass: 'create',
              btnActionEvent: 'edit',
              btnCssClass: 'btn btn-secondary'
            },*/
            {
              btnTitle: 'Duplica campo',
              btnIconClass: 'content_copy',
              btnActionEvent: 'duplicate',
              btnCssClass: 'btn btn-secondary'
            },
            {
              btnTitle: 'Elimina campo',
              btnIconClass: 'delete',
              btnActionEvent: 'remove',
              btnCssClass: 'btn btn-primary'
            }
          );
        }
      }
      //Caso template distribuito, posso solo aggiungere nuovi campi e cambiare l'ordinamento, ma non posso modificare i campi
      else if (this.templateDistribuito === "S") {

        //Caso utente DGPE
        if (this.acl === AclTipo.DGPE) {

          //Se sono un utente DGPE e il campo con cui voglio interagire è un campo DGPE allora posso
          //eseguire qualsiasi operazione, altrimenti sono di sola visualizzazione
          if (element.campoDgpe === 'S') {

            if (element.predefinito === 'N') {
              this.editToolbar.actions.push(
                {
                  btnTitle: 'Modifica',
                  btnIconClass: 'create',
                  btnActionEvent: 'edit',
                  btnCssClass: 'btn btn-secondary'
                },
                {
                  btnTitle: 'Duplica campo',
                  btnIconClass: 'content_copy',
                  btnActionEvent: 'duplicate',
                  btnCssClass: 'btn btn-secondary'
                },
                {
                  btnTitle: 'Elimina campo',
                  btnIconClass: 'delete',
                  btnActionEvent: 'remove',
                  btnCssClass: 'btn btn-primary'
                },
                {
                  btnTitle: 'Aggiungi un nuovo campo sotto il campo selezionato',
                  btnIconClass: 'add',
                  btnActionEvent: 'add-new-under',
                  btnCssClass: 'btn btn-primary'
                }
              );

              this.toolbar.actions.push(
                {
                  btnTitle: 'Modifica',
                  btnIconClass: 'create',
                  btnActionEvent: 'edit',
                  btnCssClass: 'btn btn-secondary'
                },
                {
                  btnTitle: 'Duplica campo',
                  btnIconClass: 'content_copy',
                  btnActionEvent: 'duplicate',
                  btnCssClass: 'btn btn-secondary'
                },
                {
                  btnTitle: 'Elimina campo',
                  btnIconClass: 'delete',
                  btnActionEvent: 'remove',
                  btnCssClass: 'btn btn-primary'
                }
              );

            }
          } else {
            this.editToolbar = this.toolbar
          }

        }
        // Nel caso di utente DPCPL e template distribuito va bene
        //la toolbar iniziale, poichè può solo vedere il dettaglio
        //e spostare i campi selezionati
      }
    }
    /* Caso dettaglio template */
    else if (this.router.url.includes('dettaglio-template')) {
      this.toolbar = {
        toolbarCss: 'toolbar-vertical',
        actions: [
          {
            btnTitle: 'Dettaglio',
            btnIconClass: 'article',
            btnActionEvent: 'detail',
            btnCssClass: 'btn btn-secondary'
          }
        ]
      };

      this.editToolbar = this.toolbar

      // Nel caso di utente DPCPL nel dettaglio ha tutto in readonly, se vuole modificare qualcosa
      //entrerà in modalità modifica
    }

    return element.flVisibilita === 'S' ? this.editToolbar : this.toolbar;
  }

  //funzione di controllo per visulizzazione della toolbar di ordinamento
  public checkIfElementCanMove(element): boolean {
    /* Caso modifica template */
    if (this.router.url.includes('modifica-template')) {

      //Caso non distribuito
      if (this.templateDistribuito === "N") {
        if (element.flVisibilita === 'S') {
          return true;
        }
      }
      else if (this.templateDistribuito === "S") {
        //Caso utente DGPE
        if (this.acl === AclTipo.DGPE) {

          if (element.campoDgpe === 'S') {

            if (element.flVisibilita === 'S') {
              return true;
            }
          } else {
            return false
          }

        } else if ((this.acl === AclTipo.DPCPL) || (this.acl === AclTipo.EDEL)) {
          if (element.flVisibilita === 'S') {
            return true;
          }
        } else {
          return false
        }
      }
    }
    /* Caso dettaglio template */
    else if (this.router.url.includes('dettaglio-template')) {
      return false;
    }
  }

  public handleToolbarEvent(event: ToolbarEvent): void {
    //Indica se ci sono operazioni in pending
    let pendingOperation: boolean = true;

    if (this.controlList.length == 0 && this.checkAndSave) pendingOperation = false;

    if (event.event === 'detail') {
      this.openDettaglioCampoDialog(event.data.idCampo, event.event, false)
    }
    else if (event.event === 'edit') {
      this.openDettaglioCampoDialog(event.data.idCampo, event.event, false)
    }
    // Nuovo campo per template libero
    else if (event.event === 'new-libero') {
      this.openDettaglioCampoDialog('', '', false);
    }
    // Nuovo campo C creato successivamente a quello scelto
    else if (event.event === 'add-new-under') {
      this.openDettaglioCampoDialog('', '', true, event.data.idCampo, pendingOperation);
    }
    else if (event.event === 'duplicate') {
      this.openDuplicateInputDialog(event.data);
    }
    else if (event.event === 'remove') {
      this.openRemoveCampoDialog(event.data.idCampo, this.idTemplate);
    }
    else if (event.event === 'up') {
      let direzione: string = 'U';
      let idTemplate = event.data['idTemplate'] !== null ? event.data['idTemplate'] : 0;
      this.campiService.cambiaOrdinamentoCampo(event.data['idCampo'], idTemplate, direzione, pendingOperation).subscribe(res => {
        this.alertsCenterService.showAlert({
          message: "Cambio ordinamento campo eseguito con successo",
          type: 'success',
          autoClosable: false
        });
        this.searchFilters = {
          codiceCampo: null,
          idTemplate: event.data['idTemplate'],
          tipologia: event.data['tpModulo'],
          etichetta: null,
          descrizione: null,
          obbligatorio: null,
          visualizzabile: null
        }
        this.controlList = [];
        this.dataSource.loadCampiWithCheck(this.controlList, this.searchFilters, 'codiceCampo,ASC', this.paginator.pageIndex, this.paginator.pageSize, this.templateDistribuito, this.allAbilitati);
      },
        err => {
          this.alertsCenterService.showAlert({
            message: err.error.esitoServizio.descrizioneEsito,
            type: 'danger',
            autoClosable: false
          });
        });
    }
    else if (event.event === 'down') {
      let direzione: string = 'D';


      this.campiService.cambiaOrdinamentoCampo(event.data['idCampo'], event.data['idTemplate'], direzione, pendingOperation).subscribe(res => {
        this.alertsCenterService.showAlert({
          message: "Cambio ordinamento campo eseguito con successo",
          type: 'success',
          autoClosable: false
        });
        this.searchFilters = {
          codiceCampo: null,
          idTemplate: event.data['idTemplate'],
          tipologia: event.data['tpModulo'],
          etichetta: null,
          descrizione: null,
          obbligatorio: null,
          visualizzabile: null
        }
        this.controlList = [];
        this.dataSource.loadCampiWithCheck(this.controlList, this.searchFilters, 'codiceCampo,ASC', this.paginator.pageIndex, this.paginator.pageSize, this.templateDistribuito, this.allAbilitati);
      },
        err => {
          this.alertsCenterService.showAlert({
            message: err.error.esitoServizio.descrizioneEsito,
            type: 'danger',
            autoClosable: false
          });
        });
    }
  }

  sendConf(ele) {
    ele.flVisibilita = ele.flVisibilita === 'S' ? 'N' : 'S';
    ele.editatoFE = true;
    this.emitCampiPredConf.emit(ele);
    let present = false;
    this.controlList.forEach((element, index) => {
      if (element.idCampo === ele.idCampo) {
        this.controlList.splice(index, 1);
        present = true;
      }
    });
    if (!present) this.controlList.push(ele);

  }

  setAll(completed: boolean) {
    this.checkAndSave = false;
    this.controlList = [];
    if (completed === true) {
      this.allAbilitati = "S";
    } else {
      this.allAbilitati = "N"
    }
    if (this.templateDistribuito == 'S') {
      if (this.allAbilitati == 'S') {
        this.allCampiAbilitatiEvent.emit(this.allAbilitati);
      } else {
        this.allCampiAbilitatiEvent.emit(this.acl === AclTipo.DGPE ? 'N' : '');
      }
    } else {
      this.allCampiAbilitatiEvent.emit(this.allAbilitati);
    }
    this.dataSource.loadCampiWithCheck(this.controlList, this.searchFilters, 'codiceCampo,ASC', this.paginator.pageIndex, this.paginator.pageSize, this.templateDistribuito, this.allAbilitati);
  }

  duplicateCampo(event, etichetta) {
    this.campiService.duplicateCampoConf(event.idCampo, event.idTemplate, event.tpModulo, etichetta).subscribe(res => {
      this.alertsCenterService.showAlert({
        message: `Duplicazione Campo avvenuta con successo`,
        type: 'success',
        autoClosable: false
      });
      this.ricercaListaCampi();
    }, err => {
      this.alertsCenterService.showAlert({
        message: err.error.esitoServizio.descrizioneEsito,
        type: 'danger',
        autoClosable: false
      });
    })
  }
  toggleMenu(data) {
    //more_horiz indica che il click è avvenuto sui 3 pallini della colonna azione
    if (data.srcElement.innerText !== 'more_horiz') this.openToggle = 0;
  }
  //rimane in ascolto: se il click non è fatto sull'icona chiude il menù
  @HostListener('document:click', ['$event'])
  documentClick(event) {
    if (event.srcElement.innerText !== 'more_horiz') this.openToggle = 0;
  }

  private checkDistribuito() {
    this.acl = sessionStorage.getItem('acl');

    this.templateSvc.getTemplate(this.route.snapshot.params.idTemplate).subscribe(
      res => {
        if (res.flDistribuito === "S") {
          this.templateDistribuito = "S"
        } else if (res.flDistribuito === "N") {
          this.templateDistribuito = "N"
        }
        // this.generateToolBar();
      }
    )
  }

  isDisabilitato(element: ModelEventiCalamitosi.CampoModuloDTO) {
    if (this.acl.includes(AclTipo.DPCPL)) {
      if (this.templateDistribuito === 'S' && element.flVisibilita === 'S' && element.editatoFE === undefined) return true;
      else return false;
    } else if (this.acl.includes(AclTipo.DGPE)) {
      if (this.templateDistribuito === 'S' && element.campoDgpe === 'N') return true;
      else return false;
    }
    return false;

  }

  isCampoDgpe(element) {
    if (element.campoDgpe === 'S') {
      return true;
    } else return false;
  }
}
